import React from 'react';
import { BaseCalendarProps, CalendarEvent } from './types';
import { EventChip } from './EventChip';
import { formatDate } from '@/lib/localeFormatters';

export interface DayViewProps extends BaseCalendarProps {
  day?: Date;
}

function startOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function endOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

function eventsForDay(events: CalendarEvent[] | undefined, day: Date) {
  if (!events) return [] as CalendarEvent[];
  return events.filter((e) => e.start <= endOfDay(day) && e.end >= startOfDay(day)).sort((a, b) => a.start.getTime() - b.start.getTime());
}

export const DayView: React.FC<DayViewProps> = ({
  day = new Date(),
  events,
  onEventClick,
  eventRenderer,
}) => {
  const items = eventsForDay(events, day);
  return (
    <div className="bg-card border rounded-lg">
      <div className="p-3 border-b">
        <h3 className="text-sm font-semibold">
          {formatDate(day)}
        </h3>
      </div>
      <div className="p-2 space-y-2">
        {items.length === 0 && (
          <div className="text-sm text-muted-foreground">No events</div>
        )}
        {items.map((ev) =>
          // W8-5: use custom renderer (e.g. MeetingChip with its own modal)
          // when provided, otherwise fall back to the default EventChip.
          eventRenderer ? (
            <div key={ev.id}>{eventRenderer(ev)}</div>
          ) : (
            <EventChip key={ev.id} event={ev} onClick={onEventClick} />
          )
        )}
      </div>
    </div>
  );
};
